// extracted by mini-css-extract-plugin
export default {"levelBox":"CompetenceLevelsInput_levelBox__uZOzA","levelsBox":"CompetenceLevelsInput_levelsBox__5fXAN"};